const aAvatarEdition = {
  aAvatarEdition: {
    changeAvatar: 'cambiar avatar'
  }
}

export default aAvatarEdition
